module.exports = __webpack_public_path__ + "img/map.00e013f8.png";